import { createContext, type FC, type PropsWithChildren, useMemo } from 'react';
import { useGetNotableJobInstanceCountsQuery } from '@matrix-forge/graphql-client';

export type NotableJobInstanceCountsContextValue = {
  data: ReturnType<typeof useGetNotableJobInstanceCountsQuery>['data'];
  refetch: () => any;
};

export const NotableJobInstanceCountsContext = createContext<
  NotableJobInstanceCountsContextValue | undefined
>(undefined);

interface NotableJobInstanceCountsProviderProps extends PropsWithChildren {
  pollInterval?: number | null;
}

export const NotableJobInstanceCountsProvider: FC<NotableJobInstanceCountsProviderProps> = ({
  pollInterval = 60000, // 60 seconds
  children,
}) => {
  const query = useGetNotableJobInstanceCountsQuery({
    pollInterval: pollInterval || 0,
  });
  const data = query.data || query.previousData;
  const value = useMemo(
    () => ({
      data,
      refetch: query.refetch,
    }),
    [data, query.refetch]
  );

  return (
    <NotableJobInstanceCountsContext value={value}>{children}</NotableJobInstanceCountsContext>
  );
};
